import { render } from "./EditPetBreedMore.vue?vue&type=template&id=60ad91a6&scoped=true"
import script from "./EditPetBreedMore.vue?vue&type=script&lang=js"
export * from "./EditPetBreedMore.vue?vue&type=script&lang=js"

import "./EditPetBreedMore.vue?vue&type=style&index=0&id=60ad91a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ad91a6"]])

export default __exports__